import { render } from "./VariantViewModal.vue?vue&type=template&id=5d591d2c&scoped=true"
import script from "./VariantViewModal.vue?vue&type=script&lang=js"
export * from "./VariantViewModal.vue?vue&type=script&lang=js"

import "./VariantViewModal.vue?vue&type=style&index=0&id=5d591d2c&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d591d2c"]])

export default __exports__